<template>
  <CommonLayout header="customerHeader" footer="customerFooter">
    <CustomerMeetingLayout :type="this.consts.meetingType.customer">
      <b-overlay :show="overlayShow" rounded="sm">
        <div class="base-color h-100 mh-550 shadow">
          <div class="pl-2 pb-2 pr-2 pt-0 h-100">
            <div class="col-7 p-0 d-inline-block">
              <h5 class="text-primary p-3">{{signalingData['title']}}</h5>
              <ul class="list-group mb-5">
                <li class="list-group-item border-0" v-for="(content, index) in signalingData['contents']" :key="index">・{{content}}</li>
              </ul>
            </div>
            <div class="col-5 p-0 d-inline-block position-absolute w-100">
              <img class="w-100" :src="imageUrl">
            </div>
          </div>
        </div>
      </b-overlay>
    </CustomerMeetingLayout>
  </CommonLayout>
</template>
<script>
import CommonLayout from '@/layout/CommonLayout'
import SignalingModel from '@/models/SignalingModel'
import CommonLogModel from '@/models/CommonLogModel'
import cstore from '@/store/customer-store'
import mstore from '@/store/meeting-store'
import CustomerMeetingLayout from '@/layout/CustomerMeetingLayout'

export default {
  name: 'CustomerMeetingAgenda',
  components: {CommonLayout, CustomerMeetingLayout},
  data () {
    return {
      overlayShow: false,
      signalingData: [],
      imageUrl: '',
      customerDisplayFlag: cstore.getters.customerDisplayFlag === null ? false : cstore.getters.customerDisplayFlag
    }
  },
  mounted () {
    this.imageUrl = this.config.imageURL + '/meeting-contents/agenda.jpg'
  },
  computed: {
    getSignalingData () {
      return cstore.getters.signalingReceiveData
    },
    getIsTargetAtendeeActive () {
      // 打合せ相手との疎通確立フラグ取得
      return mstore.getters.isTargetAtendeeActive
    }
  },
  watch: {
    getSignalingData (newData, oldData) {
      try {
        newData['user'] = 'customer'
        newData['timestampMs'] = Date.now()
        CommonLogModel.apiSetStore(this.$bvModal, newData, () => {
        })
        if (newData['current_path'] && oldData) {
          const synchPass = newData['current_path'].replace('florist', 'customer')
          if (synchPass !== this.$route.path) {
            return this.$router.push(synchPass)
          }
        }

        if (newData['event'] === 'click') {
          if (newData['id'] === 'next') {
            this.$router.push(newData['target_path'])
          }
          if (newData['id'] === 'reload') {
            this.signalingData = []
          }
          if (newData['id'] === 'priceHide') {
            cstore.commit('setCustomerDisplayFlag', false)
            this.customerDisplayFlag = cstore.getters.customerDisplayFlag
          } else if (newData['id'] === 'priceDisplay') {
            cstore.commit('setCustomerDisplayFlag', true)
            this.customerDisplayFlag = cstore.getters.customerDisplayFlag
          }
        }

        if (newData['event'] === 'api') {
          this.signalingData = newData.data.agenda
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    getIsTargetAtendeeActive (newData, oldData) {
      // フローリストがミーティングが有効になったか
      if (newData) {
        // アジェンダ画面表示した旨をシグナリング送信
        SignalingModel.sendStatusEvent({'show_agenda_view': 'success'})
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/CustomerMeetingAgenda.vue